import React from 'react';

const RectLoader = ({ ...props }) => <rect {...props} />;

export default RectLoader;
